var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-button',{attrs:{"type":"border","color":"secondary"},on:{"click":function($event){_vm.showPopup = true}}},[_vm._v(_vm._s(_vm.label))]),_c('popup-select891',{on:{"select":_vm.onSelect},model:{value:(_vm.showPopup),callback:function ($$v) {_vm.showPopup=$$v},expression:"showPopup"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }